"use client";

import { breakpointDesktop } from "@gnist/design-system";
import { styled } from "styled-components";
import { RangeFilterSection } from "./rangeFilterSection";
import { useFilters } from "./hooks/useFilters";
import DefaultCheckboxGroup from "./defaultCheckboxGroup";
import { TradeInCard } from "@/components/tradeIn/tradeInCard";
import { translateFilterLabels } from "@/utils/translateFilter";
import { tokens } from "@gnist/themes/tokens.css.js";

const Wrapper = styled.div`
  padding: inherit;
  border: inherit;
  display: none;
  flex-direction: inherit;
  row-gap: ${tokens.spacing.l};
  height: fit-content;

  @media screen and (min-width: ${breakpointDesktop}) {
    display: inherit;
  }
`;

export const Filters = ({ departmentSlug }: { departmentSlug?: string }) => {
  const {
    brandsWithModels,
    toggleBrandsWithModels,
    fuelFilter,
    toggleFuelFilter,
    driveWheelFilter,
    toggleDriveWheelFilter,
    priceInput,
    setPriceInput,
    modelYearInput,
    setModelYearInput,
    mileageInput,
    setMileageInput,
    onClickSearchRangeFilter,
    equipmentFilter,
    toggleEquipmentFilter,
    salesTypeFilter,
    toggleSalesTypesFilter,
    departmentsFilter,
    toggleDepartmentsFilter,
    colorFilter,
    toggleColorFilter,
    availabilityFilter,
    toggleAvailabilityFilter
  } = useFilters();

  return (
    <Wrapper>
      <TradeInCard departmentSlug={departmentSlug} />
      {availabilityFilter && availabilityFilter.length > 0 && (
        <DefaultCheckboxGroup
          headingText={translateFilterLabels("Availability")}
          checkboxFilters={availabilityFilter}
          toggleFilter={toggleAvailabilityFilter}
        />
      )}
      {departmentsFilter && departmentsFilter.length > 0 && (
        <DefaultCheckboxGroup
          headingText={translateFilterLabels("Departments")}
          checkboxFilters={departmentsFilter}
          toggleFilter={toggleDepartmentsFilter}
        />
      )}
      {brandsWithModels && (
        <DefaultCheckboxGroup
          headingText={translateFilterLabels("BrandsWithModels")}
          checkboxFilters={brandsWithModels}
          toggleFilter={toggleBrandsWithModels}
        />
      )}
      <RangeFilterSection
        headingText={translateFilterLabels("Price")}
        startRangeLabel="Fra pris"
        endRangeLabel="Til pris"
        formatInputValueWithSpacing={true}
        filter={priceInput}
        updateFilter={setPriceInput}
        onSearch={onClickSearchRangeFilter}
      />
      <RangeFilterSection
        headingText={translateFilterLabels("ModelYear")}
        startRangeLabel="Fra år"
        endRangeLabel="Til år"
        formatInputValueWithSpacing={false}
        filter={modelYearInput}
        updateFilter={setModelYearInput}
        onSearch={onClickSearchRangeFilter}
      />
      <RangeFilterSection
        headingText={translateFilterLabels("Mileage")}
        startRangeLabel="Fra km"
        endRangeLabel="Til km"
        formatInputValueWithSpacing={true}
        filter={mileageInput}
        updateFilter={setMileageInput}
        onSearch={onClickSearchRangeFilter}
      />
      {fuelFilter && (
        <DefaultCheckboxGroup
          headingText={translateFilterLabels("Fuel")}
          checkboxFilters={fuelFilter}
          toggleFilter={toggleFuelFilter}
        />
      )}
      {colorFilter && (
        <DefaultCheckboxGroup
          headingText={translateFilterLabels("Color")}
          checkboxFilters={colorFilter}
          toggleFilter={toggleColorFilter}
        />
      )}
      {driveWheelFilter && (
        <DefaultCheckboxGroup
          headingText={translateFilterLabels("DriveWheel")}
          checkboxFilters={driveWheelFilter}
          toggleFilter={toggleDriveWheelFilter}
        />
      )}
      {equipmentFilter && (
        <DefaultCheckboxGroup
          headingText={translateFilterLabels("Equipment")}
          checkboxFilters={equipmentFilter}
          toggleFilter={toggleEquipmentFilter}
        />
      )}
      {salesTypeFilter && (
        <DefaultCheckboxGroup
          headingText={translateFilterLabels("SalesType")}
          checkboxFilters={salesTypeFilter}
          toggleFilter={toggleSalesTypesFilter}
        />
      )}
    </Wrapper>
  );
};
